import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { servicesData } from '../content/servicesData';
import { companyProfile } from '../content/siteContent';

function Services() {
  return (
    <div className="inner-page">
      <Seo
        title="Services | Website Design, Web Development, Admission Guidance, Visa & Job Placement | Vedanskrix"
        description="Explore Vedanskrix services including website design, web development, mobile app development, IoT solutions, ethical hacking, SEO, admission guidance, visa guidance, and job placement."
        keywords={[
          'website design company in Ahmedabad',
          'web development company in Ahmedabad',
          'ethical hacking services in Ahmedabad',
          'IoT solutions company in Ahmedabad',
          'admission guidance services Ahmedabad',
          'job placement services in Ahmedabad',
          'seo services in Ahmedabad',
          'visa consultant Ahmedabad',
          'mobile app development Ahmedabad'
        ]}
        schema={{
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: 'Vedanskrix Services',
          url: `${companyProfile.websiteUrl}/services`,
          description: 'Service listing page for Vedanskrix technology, admission, visa, and career support offerings.'
        }}
      />

      <section className="page-hero">
        <p className="eyebrow">Services</p>
        <h1>All Vedanskrix services in one structured overview page.</h1>
        <p>
          Use this page or the header dropdown to explore every service category. Each service now
          has its own page, keyword set, and clearer inquiry path.
        </p>
      </section>

      <section className="section">
        <div className="service-stack">
          {servicesData.map((service, index) => (
            <article key={service.slug} className="service-detail-card">
              <div className="service-card-top">
                <span className="feature-code">0{index + 1}</span>
                <h2>{service.title}</h2>
              </div>
              <p>{service.summary}</p>
              <div className="service-list">
                {service.deliverables.map((item) => (
                  <div key={item} className="service-list-item">
                    <span className="service-dot" />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
              <div className="service-actions">
                <Link to={`/services/${service.slug}`} className="button-secondary">
                  Open {service.menuLabel}
                </Link>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="section section-light">
        <div className="section-heading">
          <p className="eyebrow">What Stays Consistent</p>
          <h2>Every service now follows one stronger Vedanskrix standard.</h2>
        </div>

        <div className="capability-grid">
          {[
            'Unique title and meta description for each service page',
            'Local keyword targeting aligned to Ahmedabad search phrasing',
            'Dropdown navigation for direct service discovery',
            'Consistent branded layout across all service pages'
          ].map((capability) => (
            <article key={capability} className="capability-card">
              <span className="check-badge">OK</span>
              <p>{capability}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Services;
